import {ExtrudeGeometry} from "three";
import {GeometryModifier} from "./types";
import * as THREE from "three";
import {GeneratorValues} from "../../product-types";

export const RoundBottom: GeometryModifier = {
    apply(geometry: ExtrudeGeometry, values: GeneratorValues): ExtrudeGeometry {
        const positions = geometry.attributes.position

        for (let i = 0; i < positions.count; i++) {
            const vertex = new THREE.Vector3()
            vertex.fromBufferAttribute(positions, i)

            const a = -10/(values.height * values.height)
            const scalar = a * vertex.z * vertex.z;

            const distance = new THREE.Vector2(vertex.x, vertex.y)
            const newDistance = distance.multiplyScalar(1 + scalar / distance.length())

            positions.setXYZ(i, newDistance.x, newDistance.y, vertex.z)
        }

        return geometry;
    }
}